import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NxLicenseService } from '../../../api/services';
import { accountActions } from './account.actions';
import { delay, exhaustMap, map, tap } from 'rxjs';
import { concatLatestFrom, mapResponse } from '@ngrx/operators';
import { LoadingState } from '../models/loader.model';

export const getLicenseEffect = createEffect(
  (actions$ = inject(Actions), tr = inject(NxLicenseService)) => {
    return actions$.pipe(
      ofType(accountActions.licenseLoad),
      exhaustMap((props) =>
        tr.nxLicenseControllerGetLicenseData(props).pipe(
          delay(1000),
          mapResponse({
            next: (r) => {
              accountActions.licenseStatus({ status: r.data.status });
              return accountActions.licenseDone({ data: r.data, state: { value: LoadingState.SUCCESS } });
            },
            error: (error: { error: { message: string } }) => {
              accountActions.licenseStatus({ status: 'ERROR' });
              return accountActions.licenseDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'error', text: 'impossibile caricare i dati della licenza' },
                },
              });
            },
          }),
        ),
      ),
    );
  },
  { functional: true },
);

export const monthPaymentLicenseEffect = createEffect(
  (actions$ = inject(Actions), tr = inject(NxLicenseService)) => {
    return actions$.pipe(
      ofType(accountActions.monthPaymentLoad),
      exhaustMap((props) =>
        tr.nxLicenseControllerGetLicensePaymentDataMonth(props).pipe(
          delay(1000),
          mapResponse({
            next: (r) => accountActions.monthPaymentDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: (error: { error: { message: string } }) =>
              accountActions.monthPaymentDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'error', text: 'impossibile caricare i dati per il pagamento della licenza' },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);

export const yearPaymentLicenseEffect = createEffect(
  (actions$ = inject(Actions), tr = inject(NxLicenseService)) => {
    return actions$.pipe(
      ofType(accountActions.yearPaymentLoad),
      exhaustMap((props) =>
        tr.nxLicenseControllerGetLicensePaymentDataYear(props).pipe(
          delay(1000),
          mapResponse({
            next: (r) => accountActions.yearPaymentDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: (error: { error: { message: string } }) =>
              accountActions.yearPaymentDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'error', text: 'impossibile caricare i dati della licenza' },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
